import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize
} from "certain-common-library";
import { cloneDeep } from "lodash";
import { SessionService } from "../../../../../../modules/shared/services/session-service";
import { FlashMessagesService } from "angular2-flash-messages";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

@Component({
    selector: "app-session-config",
    templateUrl: "./session-config.view.html"
})
export class SessionConfigView implements AfterViewInit, OnInit {
    columns: CclListColumn[];
    selectedFilters = [];
    filtersDropdownSettings = {};
    filters = [];
    sessionConfigObj: any;
    speakerDataConfig: any = {};

    speakerTypeIdsDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    searchConfig: any = {
        speakerTypeIds: [],
        speakerName: ""
    };
    speakerConfig = {
        eventId: this.sharedService.event.id,
        speakerName: "",
        organization: "",
        speakerType: -1,
        speakerTypeIds: [],
        limit: 10,
        page: 0,
        field: "[profile].pro_fname",
        order: "asc",
        active: true
    };
    sortCase;
    speakers: CclList = <CclList>{};
    listSelection: any = {};
    noSpeakers: boolean = false;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private templateResolver: CclTemplateResolverService,
        private cdRef: ChangeDetectorRef,
        private sessionService: SessionService,
        private _flashMessagesService: FlashMessagesService
    ) {
        this.navSecondaryService.sectionLabel = "Data";
        this.filtersDropdownSettings = {
            singleSelection: false,
            idField: "item_id",
            textField: "item_text",
            selectAllText: "All",
            unSelectAllText: "All",
            allowSearchFilter: true,
            isBasicMultiselect: true,
            maxHeight: ""
        };
        this.filters = [
            { item_id: 1, item_text: "Tracks" },
            { item_id: 2, item_text: "Type" },
            { item_id: 3, item_text: "Tags" },
            { item_id: 4, item_text: "Level" }
        ];
        this.selectedFilters = this.filters;
    }

    ngOnInit() {
        this.speakerDataConfig = this.sharedService.dataConfig[this.sharedService.sessionUrl];
        this.speakerDataConfig.selectedList.forEach((element) => {
            this.listSelection[element] = true;
        });
        this.clearAllFilter();
    }

    ngAfterViewInit(): void {
        const listTemplates = this.templateResolver.getTemplates(CclListTemplateProviderComponent, [
            CclListTemplates.icon,
            CclListTemplates.name,
            CclListTemplates.data
        ]);
        this.columns = [
            {
                label: "Speaker Name",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.xl,
                key: "fullName"
            },
            {
                label: "Organization",
                template: listTemplates[CclListTemplates.data],
                size: CclListColumnSize.xl,
                key: "organization"
            },
            {
                label: "Speaker Type",
                template: listTemplates[CclListTemplates.data],
                size: CclListColumnSize.lg,
                key: "speakerTypeName"
            }
        ];

        this.cdRef.detectChanges();
    }

    paginationFilter: any = {
        limit: 10,
        total: 0,
        count: 0,
        offset: 1
    };

    loadFilteredSessions(ev) {
        this.paginationFilter = cloneDeep(ev.pagination);
        let event = cloneDeep(ev);
        this.speakerConfig.order = "asc";
        if (event.sortDescending) {
            this.speakerConfig.order = "desc";
        }
        if (event.sortProperty) {
            if (event.sortProperty === "fullName") {
                this.speakerConfig.field = "[profile].pro_fname";
            } else {
                this.speakerConfig.field = "[" + event.sortProperty + "]";
            }
        }

        this.fetchSpeakers();
        this.paginationFilter.offset = 1;
    }

    fetchSpeakers() {
        const limit = this.paginationFilter.limit;
        const offset = (this.paginationFilter.offset - 1) * limit;
        let page = this.paginationFilter.offset - 1;
        let arrSpeakerType = [];

        if (this.searchConfig.speakerTypeIds != undefined && this.searchConfig.speakerTypeIds.length > 0) {
            this.searchConfig.speakerTypeIds.forEach(function(speaker) {
                arrSpeakerType.push(speaker.id);
            });
        }

        this.speakerConfig.speakerTypeIds = arrSpeakerType;
        this.speakerConfig.speakerName = this.searchConfig.label;
        this.speakerConfig.organization = this.searchConfig.organization;
        this.speakerConfig.limit = limit;
        this.speakerConfig.page = page;
        this.sessionService.speakerList(this.speakerConfig).subscribe((data) => {
            if (data.body != null) {
                data.body["pagination"] = {};
                data.body["pagination"]["offset"] = offset / limit + 1;
                data.body["pagination"]["limit"] = limit;
                data.body["pagination"]["total"] = data.body["count"];
                data.body["pagination"]["count"] = 5;
                this.speakers = <CclList>data.body;
                if (this.speakers.data.length > 0) {
                    this.speakers.data.forEach((element) => {
                        element["fullName"] = element["firstName"] + " " + element["lastName"];
                    });
                    setTimeout(() => {
                        var chkBoxes = jQuery(".c-list__check-box");
                        var list = this.speakerDataConfig.selectedList;
                        var count = 0;
                        this.speakers.data.forEach((speaker) => {
                            list.forEach((selectedId) => {
                                if (selectedId == speaker["id"] + "") {
                                    ++count;
                                }
                            });
                        });
                        if (count == this.speakers.data.length) {
                            chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = true;
                        } else {
                            chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
                        }
                    }, 0);
                } else {
                    this.noSpeakers = true;
                }
            } else {
                this.noSpeakers = true;
            }
        });
    }
    clearAllFilter() {
        this.searchConfig.label = "";
        this.searchConfig.organization = "";
        this.searchConfig = {
            speakerTypeIds: [],
            sessionName: this.searchConfig.label,
            organization: this.searchConfig.organization
        };
        this.fetchSpeakers();
    }

    showClearButton() {
        if (this.searchConfig.label || this.searchConfig.organization || this.searchConfig.speakerTypeIds.length > 0) {
            return true;
        } else return false;
    }

    selectSessions(list) {
        setTimeout(() => {
            var chkBoxes = jQuery(".c-list__check-box");
            var count = 0;
            this.speakers.data.forEach((speaker) => {
                list.forEach((selectedId) => {
                    if (selectedId == speaker["id"] + "") {
                        ++count;
                    }
                });
            });

            if (count == this.speakers.data.length) {
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = true;
            } else {
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
            }

            if (list != null && list.length > 20) {
                this._flashMessagesService.show("Cannot select more than 20 speakers for Featured.", {
                    cssClass: "alert-danger"
                });
                this.listSelection = {};
                this.speakerDataConfig.selectedList.forEach((element) => {
                    this.listSelection[element] = true;
                });
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
                return false;
            }

            this.speakerDataConfig.selectedList = list.map(function (elem) {
                return parseInt(elem);
              });
        }, 0);
    }

    searchQueryChanged(e) {
        this.searchConfig.label = e;
    }
}
